/* CAROUM Header Navigation V2 — click/hover desktop, nested mobile, model directory. */
(function(){
'use strict';
const modelMap=window.CaroumHeaderModelDirectoryV2||{};
function getModels(make){let match=Object.keys(modelMap).find(k=>k.toLocaleLowerCase()===String(make).toLocaleLowerCase());return match?modelMap[match]:[];}
function modelContent(container,make,limit){
  const models=getModels(make);
  container.replaceChildren();
  if(!models.length){const p=document.createElement('p');p.className='cn-model-note';p.textContent='Model links are not yet indexed here. Use Select Make / Model / Year to browse.';container.append(p);return;}
  let expanded=false;
  function render(){
    container.replaceChildren();
    const shown=expanded?models:models.slice(0,limit);
    for(const entry of shown){
      const title=String(entry.name||'').trim();if(!title)continue;
      let el;
      if(entry.url&&/^\/collections\/[a-z0-9-]+$/.test(entry.url)){
        el=document.createElement('a');el.href=entry.url;el.textContent=title;
      }else{
        el=document.createElement('button');el.type='button';el.setAttribute('data-caroum-select-vehicle','');el.textContent=title;
        el.setAttribute('aria-label','Choose '+make+' '+title+' in vehicle selector');
        el.title='Opens make / model / year selector';
      }
      container.append(el);
    }
    if(models.length>limit){
      const button=document.createElement('button');button.type='button';button.className='cn-model-more';
      button.textContent=expanded?'Show fewer models':'View all '+models.length+' models';
      button.setAttribute('aria-expanded',String(expanded));
      button.addEventListener('click',()=>{expanded=!expanded;render();});
      container.append(button);
    }
    if(models.some(m=>!m.url)){
      const p=document.createElement('p');p.className='cn-model-note';p.textContent='Some models require make, model and year selection before browsing available parts.';container.append(p);
    }
  }
  render();
}
function init(root){
 if(root.dataset.cnReady)return;root.dataset.cnReady='1';
 const navMenus=[...root.querySelectorAll('[data-cn-menu]')];
 function closeAll(){for(const item of navMenus){const btn=item.querySelector('[data-cn-trigger]'),panel=item.querySelector('[data-cn-panel]');btn.setAttribute('aria-expanded','false');panel.hidden=true;}}
 function open(menu){closeAll();const item=navMenus.find(el=>el.dataset.cnMenu===menu);if(!item)return;item.querySelector('[data-cn-trigger]').setAttribute('aria-expanded','true');item.querySelector('[data-cn-panel]').hidden=false;}
 for(const item of navMenus){
   const btn=item.querySelector('[data-cn-trigger]');
   btn.addEventListener('click',(event)=>{const hoverDesktop=window.matchMedia('(hover:hover) and (min-width:1024px)').matches;if(hoverDesktop && event.detail>0){open(item.dataset.cnMenu);return;}const openNow=btn.getAttribute('aria-expanded')==='true';if(openNow)closeAll();else open(item.dataset.cnMenu);});
   if(window.matchMedia('(hover:hover) and (min-width:1024px)').matches){
     item.addEventListener('pointerenter',()=>open(item.dataset.cnMenu));
   }
 }
 root.addEventListener('pointerleave',()=>{if(window.matchMedia('(hover:hover) and (min-width:1024px)').matches)closeAll();});
 root.addEventListener('keydown',event=>{if(event.key==='Escape'){const active=root.querySelector('[data-cn-trigger][aria-expanded=true]');if(active){closeAll();active.focus();}}});
 document.addEventListener('pointerdown',event=>{if(!root.contains(event.target))closeAll();});
 const parts=root.querySelector('[data-cn-parts-open]');const partContent=root.querySelector('[data-cn-parts-content]');
 parts?.addEventListener('click',()=>{partContent.hidden=false;parts.setAttribute('aria-expanded','true');});
 const brandsBtn=root.querySelector('[data-cn-brands-open]');
 const brandList=root.querySelector('[data-cn-brand-list]');
 brandsBtn?.addEventListener('click',()=>{brandList.hidden=false;brandsBtn.setAttribute('aria-expanded','true');});
 const modelPanel=root.querySelector('[data-cn-models-panel]');
 const modelList=root.querySelector('[data-cn-model-list]');
 for(const button of root.querySelectorAll('[data-cn-brand]')){
   button.addEventListener('click',()=>{
     for(const item of root.querySelectorAll('[data-cn-brand]'))item.setAttribute('aria-pressed',String(item===button));
     const make=button.dataset.cnBrand;modelPanel.hidden=false;root.querySelector('[data-cn-model-heading]').textContent=make+' models';
     root.querySelector('[data-cn-make-viewall]').href=button.dataset.cnBrandUrl;
     root.querySelector('[data-cn-make-viewall]').textContent='View all '+make+' Parts ↗';
     modelContent(modelList,make,12);
   });
 }
 const vehiclePanel=root.querySelector('[data-cn-panel="vehicles"]');
 if(vehiclePanel){
   const regions=[...vehiclePanel.querySelectorAll('[data-cn-region]')];
   const panes=[...vehiclePanel.querySelectorAll('[data-cn-region-panel]')];
   function selectRegion(regionId){
     for(const b of regions)b.setAttribute('aria-pressed',String(b.dataset.cnRegion===regionId));
     for(const p of panes)p.hidden=p.dataset.cnRegionPanel!==regionId;
   }
   for(const button of regions){
     button.addEventListener('click',()=>selectRegion(button.dataset.cnRegion));
     button.addEventListener('pointerenter',event=>{
       if(event.pointerType==='mouse' && window.matchMedia('(hover:hover) and (min-width:1024px)').matches){
         selectRegion(button.dataset.cnRegion);
       }
     });
   }
 }

}
function initMobile(root){
 if(root.dataset.cnReady)return;root.dataset.cnReady='1';
 for(const detail of root.querySelectorAll('[data-cn-make]')){
   detail.addEventListener('toggle',()=>{if(detail.open){const c=detail.querySelector('[data-cn-model-list]');if(!c.dataset.cnBuilt){modelContent(c,detail.dataset.cnMake,8);c.dataset.cnBuilt='true';}}});
 }
}
function ready(){
 for(const nav of document.querySelectorAll('.cn-desktop[data-cn-root]'))init(nav);
 for(const nav of document.querySelectorAll('.cn-mobile[data-cn-root]'))initMobile(nav);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
document.addEventListener('shopify:section:load',ready);
})();